<ng-content>

</ng-content>

<ui-spinner *ngIf="loading" size="large" class="≈absolute ≈left-1/2 ≈top-1/2">

</ui-spinner>
